<template>
        <v-row>
          <v-col cols="4" v-if="showForm">
            <ProsthesisForm
              :surgeryIndicationId="surgeryIndication.id"
              :surgeryIndicationProsthesis="currentProsthesis"
            />
          </v-col>

          <v-col>
            <v-row v-if="!lodash.isEmpty(chosenSurgeryIndicationProstheses)">
              <v-col class="text-h5 gray--text"> Próteses Escolhidas </v-col>
            </v-row>

            <ProsthesisItem
              v-for="surgeryIndicationProsthesis in chosenSurgeryIndicationProstheses"
              :key="surgeryIndicationProsthesis.id"
              :surgeryIndication="surgeryIndication"
              :surgeryIndicationProsthesis="surgeryIndicationProsthesis"
              :editProsthesis="editProsthesis"
              :allowDelete="allowDelete"
              :allowEdit="allowEdit"
            />

            <v-row v-if="!lodash.isEmpty(notChosenSurgeryIndicationProstheses)">
              <v-col class="text-h5 gray--text"> Próteses Sugeridas </v-col>
            </v-row>

            <ProsthesisItem
              v-for="surgeryIndicationProsthesis in notChosenSurgeryIndicationProstheses"
              :key="surgeryIndicationProsthesis.id"
              :surgeryIndication="surgeryIndication"
              :surgeryIndicationProsthesis="surgeryIndicationProsthesis"
              :editProsthesis="editProsthesis"
              :allowDelete="allowDelete"
              :allowEdit="allowEdit"
            />
          </v-col>
        </v-row>
</template>

<script>
import ProsthesisForm from "@/components/surgery_indication/prosthesis/form.vue";
import ProsthesisItem from "@/components/surgery_indication/prosthesis/list/item.vue";
import ON_SURGERY_INDICATION_PROTHESIS_UPDATED from "@/graphql/subscriptions/surgery_indication/prothesis_updated.gql";
import { buildSubscription } from "@/components/graphql/subscriptions.js";


export default {
  name: "ProsthesisList",
  props: {
    surgeryIndicationProstheses: Array,
    surgeryIndication: Object,
    showForm: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
    onlyChosen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ProsthesisForm,
    ProsthesisItem,
  },
  data() {
    return {
      currentProsthesis: null,
      subscriptionLoaded: false,
    };
  },
  apollo: {
    $subscribe: {
      surgeryIndicationProsthesisUpdated() {
        return buildSubscription({
          query: ON_SURGERY_INDICATION_PROTHESIS_UPDATED,
          variables: {
            surgeryIndicationId: this.surgeryIndication.id,
          },
          onSuccess: (payload) => {
            const { prostheses } = payload.surgeryIndicationProsthesisUpdated;
            this.$emit('update-surgery-indication-prostheses', prostheses);
          },
          onSubscriptionLoadStatusUpdate: (value) => {
            this.subscriptionLoaded = value;
          },
          errorNotificationMessage:
            "Ocorreu um erro ao tentar atualizar as próteses de indicadas para a cirurgia.\n" +
            "Você não está recebendo mais atualizações, recarregue a página para atualizar.",
        })
      }
    }
  },
  computed: {
    chosenSurgeryIndicationProstheses() {
      return this.lodash.filter(this.surgeryIndicationProstheses, "chosen");
    },
    notChosenSurgeryIndicationProstheses() {
      if (this.onlyChosen) {
        return [];
      }

      return this.lodash.filter(
        this.surgeryIndicationProstheses,
        (e) => !e.chosen
      );
    },
  },
  methods: {
    editProsthesis(prosthesis) {
      this.currentProsthesis = prosthesis;
    }
  },
};
</script>

<style lang="scss" scoped></style>
